import { render, staticRenderFns } from "./itSupport.vue?vue&type=template&id=33e86169&"
import script from "./itSupport.vue?vue&type=script&lang=js&"
export * from "./itSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports